import { Action } from './action';

function condition() {
  return true;
}

export const undoAction = new Action({
  name: 'Undo',
  handler: (stageContext) => stageContext.api.undo(),
  shortcuts: 'Ctrl+z',
  command: 'Ctrl+Z',
  condition: (ctx) => {
    // 文本编辑时交给 TextProvider 处理字符级撤销
    if (ctx?.providers?.text?.currentNode) return false;
    return condition();
  },
});

export const redoAction = new Action({
  name: 'Redo',
  handler: (stageContext) => stageContext.api.redo(),
  shortcuts: 'Ctrl+Shift+Z',
  command: 'Ctrl+Shift+Z',
  condition: (ctx) => {
    if (ctx?.providers?.text?.currentNode) return false;
    return condition();
  },
});
